import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { MUSHROOMS as STATIC_MUSHROOMS } from "../data/mushrooms";

const MushroomsContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function MushroomsProvider({ children }) {
  const [mushrooms, setMushrooms] = useState(STATIC_MUSHROOMS);
  const [loading, setLoading] = useState(true);

  const fetchMushrooms = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/mushrooms`);
      if (res.data && res.data.length > 0) setMushrooms(res.data);
    } catch {
      // Silently fall back to static mushroom data — no network available or API error
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMushrooms(); }, [fetchMushrooms]);

  return (
    <MushroomsContext.Provider value={{ mushrooms, loading, refetch: fetchMushrooms }}>
      {children}
    </MushroomsContext.Provider>
  );
}

export const useMushrooms = () => useContext(MushroomsContext);
